import moment from 'moment'

export default {
	toUTC(time, format = 'HH:mm') {
		return moment(time, format).utc().format(format);
	},
	toLocal(time, format = 'HH:mm') {
		let utcTime, localTime;

		utcTime = moment.utc(time, format);
		localTime = moment.utc(utcTime).toDate();

		return moment(localTime).format(format)
	}
}



// WEBPACK FOOTER //
// ./src/common/UTC.js